module.exports = __webpack_public_path__ + "img/backButton.2147ca45.jpg";